import { render } from "./AdminActions.vue?vue&type=template&id=1c63d7a8"
import script from "./AdminActions.vue?vue&type=script&lang=js"
export * from "./AdminActions.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/etl/etl/outerspace-admin-2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__